import ThemePlaceholder from "components/Common/ThemePlaceholder"

const formatDateValue = value => {
  if (!value) return null

  try {
    return new Date(value).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
  } catch {
    return value
  }
}

const getSummaryItems = employee =>
  [
    employee?.employee_id ? `ID: ${employee.employee_id}` : null,
    employee?.employment_type
      ? employee.employment_type
          .split("_")
          .join(" ")
          .replace(/\b\w/g, char => char.toUpperCase())
      : null,
    employee?.joining_date ? `Joined ${formatDateValue(employee.joining_date)}` : null,
  ].filter(Boolean)

export default function EmployeeInfo({ employee, loading = false }) {
  const summaryItems = getSummaryItems(employee)

  return (
    <div>
      {loading ? (
        <ThemePlaceholder style={{ width: 300, height: 28, borderRadius: 6 }} />
      ) : (
        <div className="d-flex align-items-center">
          <h4 className="mb-0 me-2 fw-semibold">{employee?.name || "Employee"}</h4>
        </div>
      )}

      <div className="d-flex align-items-center mt-2 justify-content-between">
        {loading ? (
          <ThemePlaceholder style={{ width: 220, height: 20, borderRadius: 6 }} />
        ) : (
          <p className="text-muted mb-0 d-flex flex-wrap align-items-center gap-2">
            {summaryItems.length ? (
              summaryItems.map((item, index) => (
                <span key={item} className="d-inline-flex align-items-center">
                  {index > 0 ? <i className="bx bx-radio-circle-marked font-size-10 mx-2" /> : null}
                  <span>{item}</span>
                </span>
              ))
            ) : (
              <span>-</span>
            )}
          </p>
        )}
      </div>
    </div>
  )
}
